import React from 'react';

import { BrowserSizeContext } from './useBrowserSize';

import { SIZE_SM, SIZE_MD } from '../utils/screens';

function isMobileWidth(browserSize: string): boolean {
  return browserSize === SIZE_SM || browserSize === SIZE_MD;
}

function useMobile() {
  const browserSize = React.useContext(BrowserSizeContext);
  return isMobileWidth(browserSize);
}

export default useMobile;
